const Vue = window.Vue;

Vue.component('GpsrSafetyInfo', () => import('./app/components/GpsrSafetyInfo.vue'));
